module.exports = __webpack_public_path__ + "manhattan_nannies.jpg?a22455ce450baa7b9966b49a5c4ad6e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/manhattan_nannies.jpg
// module id = 118
// module chunks = 0